import { Store, applyMiddleware, combineReducers, createStore } from 'redux';

import { composeWithDevTools } from '@redux-devtools/extension';
import createSagaMiddleware from 'redux-saga';
import { moduleNamespace } from './config.store';
import reducers from '@Reducers';
import rootSaga from '../sagas';
import { reducers as sharedReducers } from '@innovyze/stylovyze';
import {
	assetSchemaRootReducer,
	assetSchemaRootSaga,
} from '@innovyze/lib_asset_schema_store';
import { all } from 'redux-saga/effects';

const sagaMiddleware = createSagaMiddleware();

const store: Store = createStore(
	combineReducers({
		[moduleNamespace]: reducers,
		...sharedReducers,
		...assetSchemaRootReducer,
	}),
	composeWithDevTools(applyMiddleware(sagaMiddleware)),
);

const mainSaga = function* () {
	yield all([rootSaga, assetSchemaRootSaga()]);
};

sagaMiddleware.run(mainSaga);

export default store;
